/**
 * BEE-5234: 더빙 언어 선택지.
 *
 * 백엔드 common.choices.DubbingLanguage 및 content.Dubbing.LANG_CHOICES 와
 * 같은 코드값을 쓴다. 한쪽만 고치면 라벨이 어긋나므로 함께 유지할 것.
 *
 * 실제 더빙 파일과 별개인 선언값이다. 파일이 아직 없어도 Ops 가 설정할 수 있다.
 */
export type DubbingLanguageCode = 'en' | 'ko' | 'jp' | 'es' | 'zh' | 'vi';

export interface DubbingLanguageOption {
  value: DubbingLanguageCode;
  label: string;
}

export const DUBBING_LANGUAGE_OPTIONS: DubbingLanguageOption[] = [
  { value: 'en', label: 'English' },
  { value: 'ko', label: 'Korean' },
  { value: 'jp', label: 'Japanese' },
  { value: 'es', label: 'Spanish' },
  { value: 'zh', label: 'Chinese' },
  { value: 'vi', label: 'Vietnamese' },
];
